module.exports = __webpack_public_path__ + "static/card-education-programs-2-7df3fe392dd77eac15873da87c9c3edb.jpg";